
// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useDispatch, useSelector } from 'react-redux';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

// CUSTOM 
import { storeUpdateDevice } from '../../../../../store/ratings';
import MultipleSnackbars from '../../../../../components/MultipleSnackbars';
import { CreateDevice } from '../crear/CreateDevice'; // Reusing the fields component
import { closeSessionGlobal } from '../../../../../commons/utils';
import { timeToClosedToast } from '../../../../../commons/values';
import { ModalSessionExpired } from '../../../../../components/generics/ModalSessionExpired';
import validationSchema from '../formModels/crear/validationSchema';
import createDeviceFormModel from '../formModels/crear/createDeviceFormModel';
import { SnackAlert } from '../../../../../components/SnackAlert';



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));



export const EditRatingsDevice = (props: any) => {

  const { open, handleCloseModalEditar } = props;

  // DISPATCH 
  const dispatch = useDispatch();

  // REDUX 
  const { device, users_select_ratings_devices }: any = useSelector((state: any) => state.ratingsDevices);


  // USE STATE 
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);
  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);
  const [txtBtnDevice, setTxtBtnDevice] = React.useState<string>('Actualizar Dispositivo');

  const [msgSnack, setMsgSnack] = React.useState({
    msg: '',
    status: 'success'
  });


  // DATA MODELS 
  const { formId, formField } = createDeviceFormModel;
  const currentValidationSchema = validationSchema[0];


  // INITIAL VALUES FROM DETAIL
  // We need to map the user IDs to objects if they exist in the permissions list


  const formInitialValues = {
    id: device?.id || '',
    [formField.name.name]: device?.name || '',
    [formField.description.name]: device?.description || '',
    [formField.is_user_required.name]: device?.isUserRequired === 1,
    [formField.is_single_user.name]: device?.isSingleUser === 1,
    [formField.is_multi_user.name]: device?.isMultiUser === 1,
    [formField.all_users.name]: device?.allUsers === 1,
    [formField.users.name]: device?.isSingleUser === 1 ? (device?.users?.[0] || null) : (device?.users || []),
    [formField.logo_device.name]: (device?.logoDevice && typeof device.logoDevice === 'object') ? device.logoDevice.imgName : device?.logoDevice || null,
    [formField.logo_quality.name]: (device?.logoQuality && typeof device.logoQuality === 'object') ? device.logoQuality.imgName : device?.logoQuality || null,
    logo_device_preview: '',
    logo_quality_preview: ''
  };


  const handleClose = () => {
    handleCloseModalEditar(false);
  };


  const _handleSubmit = async (values: any, actions: any) => {

    setTxtBtnDevice('Actualizando...');
    actions.setSubmitting(true);
    setIsSubmiting(true);

    const usersValue = values[formField.users.name];
    const usersIds = Array.isArray(usersValue) 
      ? usersValue.map((u: any) => u.value || u) 
      : (usersValue ? [usersValue.value || usersValue] : []);

    const { logo_device_preview, logo_quality_preview, ...cleanValues } = values;

    const valuesToSend = {
      ...cleanValues,
      [formField.is_user_required.name]: values[formField.is_user_required.name] ? 1 : 0,
      [formField.is_single_user.name]: values[formField.is_single_user.name] ? 1 : 0,
      [formField.is_multi_user.name]: values[formField.is_multi_user.name] ? 1 : 0,
      [formField.all_users.name]: values[formField.all_users.name] ? 1 : 0,
      [formField.users.name]: usersIds
    };

    const response = await dispatch(storeUpdateDevice(valuesToSend));

    await setTxtBtnDevice('Actualizar Dispositivo');

    const result = await validateResponseUpdate(response, ' ( Actualizar Dispositivo ) ');

    if (response.code == 409) {
      setIsSubmiting(false);
    }

    if (!result) {
      return false;
    }

    setIsSubmiting(false);

    if (response.ok) {
      const successMsg = {
        msg: 'Dispositivo Actualizado Con Exito',
        status: 'success'
      };

      await setMsgSnack(successMsg);
      await setAlertSnack(true);

      actions.setSubmitting(false);
      handleCloseModalEditar(false);
    }
  }


  const validateResponseUpdate = async (response: any, textActionConcat: string) => {

    if (response.code == 401) {
      await localStorage.removeItem('lastSelectedQypht');
      await closeSessionGlobal();
      await handleCloseModalEditar(false);
      setModalSessionExpired(true);
      return false;
    }

    if (!response.ok && (response.code == 403 || response.code == 409)) {
      const errors: any = {
        msg: (response.errors[0] || response.errors) + ' ' + textActionConcat,
        status: 'error'
      };
      await setMsgSnack(errors);
      await setAlertSnack(true);
      return false;
    }

    if (!response.ok && response.code == 400) {
      const errors: any = [];
      response.errors.forEach((element: any) => {
        errors.push({
          type: 'error',
          text: element
        });
      });
      setMessagesAlerts(errors);
      return false;
    }

    return true;
  }


  return (
    <React.Fragment>
      <ModalSessionExpired open={modalSessionExpired} />
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status} />

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="edit-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2, fontWeight: 700, display: 'flex', alignItems: 'center' }} id="detail-dialog-title">
          <Box sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(105, 108, 255, 0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mr: 2,
                    color: '#696cff'
                }}>
                    <EditOutlinedIcon sx={{ fontSize: 24 }} />
          </Box>
          <Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#32475CDE', lineHeight: 1.2 }}>
                  Editar Dispositivo
              </Typography>
              <Typography variant="body2" sx={{ color: '#32475C99', mt: 0.5 }}>
                  Editar información del dispositivo de calificación
              </Typography>
          </Box>
      </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid>
            {device && (
              <Formik
                initialValues={formInitialValues}
                validationSchema={currentValidationSchema}
                onSubmit={_handleSubmit}
                enableReinitialize={true}
              >
                <>
                  <Form id={formId}>
                    <CreateDevice formField={formField} />

                    <Button
                      disabled={isSubmiting}
                      style={{ margin: 5, float: 'right' }}
                      type="submit"
                      variant="contained"
                      color={"primary"}
                    >
                      {txtBtnDevice}
                    </Button>
                  </Form>
                </>
              </Formik>
            )}
          </Grid>
        </DialogContent>
        <DialogActions />
      </BootstrapDialog>
    </React.Fragment>
  );
}
